
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextPage } from 'next';
import styled from 'styled-components';
import Layout from '../components/Layout';
import Text from '../components/Text';
import { space } from '../stylesheets';
const PageLayout = styled.div `
  flex-grow: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const NotFoundPage: NextPage = () => (<Layout>
    <PageLayout>
      <Text variant="headline-1" as="h1">
        404
      </Text>
    </PageLayout>
  </Layout>);
export default NotFoundPage;

    async function __Next_Translate__getStaticProps__18f80c52fb1__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/404',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18f80c52fb1__ as getStaticProps }
  